import { Injectable } from '@angular/core';
import { ApiDataService } from '@core/services/api/api-data.service';

@Injectable({providedIn: 'root'})
export class ApiNewsService extends ApiDataService {
  apiUrl = 'client/news';
}
